<template>
  <div id="update-periode" class="m-t-10">
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label for="jenis-data">Jenis Data</label>
        <select
          disabled
          id="jenis-data"
          class="form-control rounded"
          v-model="tipe"
        >
          <option value="" disabled selected>Pilih Jenis Data</option>
          <option value="medsos">Media Sosial</option>
          <option value="medkon">Media Konvensional</option>
        </select>
      </div>
      <div class="form-group">
        <label style="font-size: 14px">File</label>
        <div class="custom-file">
          <input
            type="text"
            disabled
            class="form-control rounded"
            placeholder="Pilih File"
            v-model="file_input"
          />
        </div>
      </div>
      <div class="form-group mt-3">
        <label for="IDTask">ID Task SiIteung</label>
        <input
          id="IDTask"
          type="text"
          v-model="id_task"
          class="form-control rounded"
          placeholder="Masukkan ID Task"
        />
      </div>
      <div class="form-group">
        <label for="tanggal">Periode Data</label> <br />
        <date-picker
          v-model="periode"
          valueType="format"
          type="datetime"
          range
          class="w-100"
        ></date-picker>
      </div>
      <div class="form-group mt-5" align="right">
        <button
          type="button"
          id="close-modal"
          class="btn btn-danger m-r-5"
          data-dismiss="modal"
        >
          Batal
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="!tipe || !file_input || !periode"
        >
          <span>Update</span>
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import $ from "jquery";

export default {
  nama: "modal_update_periode",
  components: {
    DatePicker,
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      tipe: this.data.tipe,
      file_input: this.data.file_input,
      id_task: this.data.id_task,
      periode: [this.data.periode.start, this.data.periode.end],
    };
  },
  methods: {
    getData: function(f) {
      let file = f.target.files[0];
      this.file_input = file;
    },
    submitForm: function() {
      var closeButton = document.getElementById("close-modal");
      let params = {
        _id: this.data.id,
        jenis_data: this.tipe,
        id_task: this.id_task,
        periode:
          moment(this.periode[0]).format("YYYY-MM-DD HH:mm:ss") +
          " - " +
          moment(this.periode[1]).format("YYYY-MM-DD HH:mm:ss"),
      };
      let api = process.env.VUE_APP_API_URL + "datacleansing-update";
      this.$http
        .put(api, params)
        .then(() => {
          this.$parent.$parent.getHistory();
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-check-circle"></i> Data Berhasil diubah.',
              position: "top",
              timeout: 4000,
              type: "success",
            })
            .show();
        })
        .catch(() => {
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-check-circle"></i> Error! Terjadi kesalahan saat mengubah data.',
              position: "top",
              timeout: 4000,
              type: "error",
            })
            .show();
        })
        .finally(() => {
          if (closeButton) {
            closeButton.click();
          }
        });
    },
  },
};
</script>
